import { EMoneySource } from '../../../types/reducers/user';

type TParams = {
  isSubagent: boolean;
  selectedMoneySource: EMoneySource | null;
  isInsufficientFunds: boolean;
};

export const masterHasNotEnoughMoney = ({ isInsufficientFunds, selectedMoneySource, isSubagent }: TParams) =>
  isSubagent && selectedMoneySource === EMoneySource.Master && isInsufficientFunds;
